import script from "./intoFactoryUnqualifiedDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./intoFactoryUnqualifiedDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./intoFactoryUnqualifiedDetailPage.vue?vue&type=style&index=0&id=aaa52834&lang=scss"

const __exports__ = script;

export default __exports__